import primaryComponents from "../../../primaryComponents";
import { useExpenseDepartmentForm } from "./useCreateExpenseDepartment";
import { useValidation } from "./useValidation";

export const ExpenseDepartmentForm = ({
  departmentDetails = null,
  isEditMode = false,
  closeModal = () => {},
}) => {
  const {
    isCreatingDepartment,
    formData,
    setFormData,
    handleAddExpenseDepartment,
  } = useExpenseDepartmentForm({
    departmentDetails,
    isEditMode,
    closeModal,
  });
  const {
    handleSubmit,
    formState: { errors },
    control,
    trigger,
  } = useValidation({ ...formData });

  return (
    <form id="departmentForm">
      <primaryComponents.InputFieldV2
        name="name"
        control={control}
        label="Department Name"
        isRequired
        placeholder="Enter your Department name"
        type="text"
        classNames="white"
        errorMessage={errors.name}
        value={formData?.name}
        onKeyUp={() => errors.name !== undefined && trigger("name")}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, name: value }));
        }}
      />

      <primaryComponents.Button
        classNames="btn btn--primary cover mt-4"
        form="departmentForm"
        type="submit"
        isLoading={isCreatingDepartment}
        isDisabled={isCreatingDepartment}
        loadingText={!isEditMode ? "Creating..." : "Updating..."}
        onClick={handleSubmit(handleAddExpenseDepartment)}
      >
        {!isEditMode ? "Create Department" : "Update Department"}
      </primaryComponents.Button>
    </form>
  );
};
